import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ViewersService } from '../../../services/viewers.service';
import { VrButtonComponent } from './vr-button/vr-button.component';
import { Subscription } from 'rxjs';
import { StreamButtonComponent } from './stream-button/stream-button.component';

@Component({
  selector: 'app-overlay-btns',
  imports: [VrButtonComponent, StreamButtonComponent],
  templateUrl: './overlay-btns.component.html',
  styleUrl: './overlay-btns.component.css'
})
export class OverlayBtnsComponent implements OnInit, OnDestroy {
  // @ViewChild('closeFullscreenBtn', {static: true, read: ElementRef}) 
  // private readonly closeFullscreenBtn!: ElementRef<HTMLElement>;
  @Input() isVrView?: boolean
  // public currentView: 'topview' | 'seatmap' | 'view3d' = 'topview';
  public currentMap!: 'topview' | 'seatmap';
  public is3dView!: boolean;
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly viewersService: ViewersService
  ) { }

  ngOnInit(): void {
    this.updateViewStep();
  }

  private updateViewStep(): void {
    // Get 3D View status
    const is3d: Subscription = this.viewersService.is3dView.subscribe((is3d: boolean) => {
      this.is3dView = is3d;
    });
    // Get Map View status
    const current: Subscription = this.viewersService.currentMap.subscribe((current: 'topview' | 'seatmap') => {
      this.currentMap = current;
    });
    this.subscriptions.push(is3d, current);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  //#region NAVIGATION METHODS
  public onBack() {
    if (this.is3dView) {
      this.viewersService.close3dView();
    } else if (this.currentMap === 'seatmap') {
      const load = this.viewersService.loadMap().subscribe();
      this.subscriptions.push(load);
    }
  }

  public onHome() {
    this.viewersService.close3dView();
    const loadhome = this.viewersService.loadMap().subscribe();
    this.subscriptions.push(loadhome);
  }
  //#endregion


  //#region MAP FEATURES METHODS
  public onLink() {
    // todo
  }

  public onFullscreen() {
    this.viewersService.viewer3d.toggleFullscreen();
  }
  //#endregion

}
